module.exports = __webpack_public_path__ + "img/پیچیده.028d9a95.jpg";